export class Patient {
    id?: string;
    first_name: string = '';
    last_name: string = '';
    date_of_birth: string = '';
    sex: string = 'N/A';
    email: string = '';
    zipcode: string = '';
    phone_country_code: string = '';
    phone: string = '';
    height: string;
    height_2: string;
    weight: string;
    allergies: string = 'None';
    medications: string = 'None';
    medical_history: string = 'None';
    surgical_history: string = 'None';
    patientID: string = '';
    avatar: string = '';
    units: string = '';
    timezone: { label: string, value: string };
    profile_image: string = '';
    envelope_id?: string;
    signed_policy?: boolean = false;
    created_by?: string;
    created_at?: string = '';
    updated_at?: string = '';
}